import type FormModal from './FormModal';

class FormModalHandle {
  constructor(private modal: FormModal) {}

  scrollToTop() {
    this.modal.scrollToTop();
  }

  close() {
    this.modal.isSubmitting = false;

    this.modal.close();
  }

  enableForm() {
    return this.modal.enableForm();
  }

  getButtonSubmit() {
    return this.modal.$btnSubmit[0] as HTMLButtonElement;
  }
}

export default FormModalHandle;
